/* ===== CRÉAFORCE ™ — shared behaviour ===== */
(function(){
  'use strict';
  if(window.__cfaInit){return;} window.__cfaInit=true;   // idempotent: safe if included on every section

  /* ---- CTA scroll to the native buy-box quantity selector ---- */
  function headerOffset(){
    var h=document.querySelector('.section-header, header.header, #shopify-section-sections--header, sticky-header');
    var hh=h?h.getBoundingClientRect().height:0;
    if(!hh||hh>140) hh=90;            // clamp: this theme reports a huge sticky height
    return hh+10;
  }
  function target(){
    return document.getElementById('cfa-buybox')
        || document.querySelector('.quantity-break, quantity-selector, .product-form__quantity, .product-form')
        || document.getElementById('MainContent');
  }
  function scrollToBuybox(e){
    if(e){e.preventDefault();}
    var t=target(); if(!t) return;
    var y=t.getBoundingClientRect().top+window.pageYOffset-headerOffset();
    window.scrollTo({top:y<0?0:y,behavior:'smooth'});
  }
  document.addEventListener('click',function(e){
    var el=e.target.closest('[data-cfa-scroll]');
    if(el) scrollToBuybox(e);
  });

  /* ---- §07 "Pick a benefit" tabs ---- */
  document.addEventListener('click',function(e){
    var tab=e.target.closest('[data-cfa-tab]');
    if(!tab) return;
    var root=tab.closest('[data-cfa-tabs]'); if(!root) return;
    var key=tab.getAttribute('data-cfa-tab');
    root.querySelectorAll('[data-cfa-tab]').forEach(function(t){
      t.classList.toggle('is-active',t===tab);
    });
    root.querySelectorAll('[data-cfa-panel]').forEach(function(p){
      p.classList.toggle('is-active',p.getAttribute('data-cfa-panel')===key);
    });
  });

  /* ---- carousels (prev/next arrow rows) ---- */
  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-cfa-car]');
    if(!btn) return;
    var root=btn.closest('[data-cfa-carousel]'); if(!root) return;
    var track=root.querySelector('[data-cfa-track]'); if(!track) return;
    var dir=btn.getAttribute('data-cfa-car')==='next'?1:-1;
    var card=track.querySelector('*');
    var step=card?card.getBoundingClientRect().width+16:300;
    track.scrollBy({left:dir*step,behavior:'smooth'});
  });

  /* ---- video testimonials: click to play, click to pause (custom overlay) ---- */
  function initVideos(){
    document.querySelectorAll('[data-cfa-video]').forEach(function(item){
      var v=item.querySelector('video');
      if(!v || item.__cfaVid) return; item.__cfaVid=true;
      item.addEventListener('click',function(e){
        if(e.target.closest('[data-cfa-car]')) return;
        if(v.paused){ var p=v.play(); if(p&&p.catch)p.catch(function(){}); }
        else { v.pause(); }
      });
      v.addEventListener('play', function(){ item.classList.add('is-playing'); });
      v.addEventListener('pause',function(){ item.classList.remove('is-playing'); });
      v.addEventListener('ended',function(){ item.classList.remove('is-playing'); });
    });
  }
  if(document.readyState!=='loading') initVideos();
  else document.addEventListener('DOMContentLoaded', initVideos);

  /* ---- per-card expand (clinician reviews "Voir plus") ---- */
  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-cfa-expand]');
    if(!btn) return;
    var card=btn.closest('.cfa11-card')||btn.parentNode;
    card.classList.toggle('cfa-open');
    var open=card.classList.contains('cfa-open');
    btn.textContent=open?(btn.getAttribute('data-less-label')||'Voir moins'):(btn.getAttribute('data-more-label')||'Voir plus');
  });

  /* ---- "show more" toggles (review walls) ---- */
  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-cfa-more]');
    if(!btn) return;
    var root=btn.closest('[data-cfa-morewrap]')||document;
    root.classList.toggle('cfa-open');
    var open=root.classList.contains('cfa-open');
    var more=btn.getAttribute('data-more-label')||'Voir plus d’avis';
    var less=btn.getAttribute('data-less-label')||'Voir moins';
    btn.textContent=open?less:more;
  });
})();
